import {Utils} from 'common/scripts/utils';

class Preloader {
    init(options) {
        this.elem = options.elem;

        if (!this.elem) {
            return;
        }

        this.parent = document.querySelector(options.parent || '.j-grid');
        this._bindEvents();
    }

    _bindEvents() {
        $(document).ready(() => {
            this._remove();
        });
    }

    _remove() {
        this.elem.classList.add('is-ready');

        setTimeout(() => {
            this.parent.classList.remove('is-loading');
            Utils.removeElement(this.elem);
        }, 500);
    }
}

export default Preloader;
